export const CHART_DATA_UPDATED = "chartDataUpdated";
